import styled from 'styled-components'
import { theme } from '@/client/components'
const { color, space, breakpoint } = theme

const getTypeColor = (type: string) => {
  if (type === 'facebook') return '#0062E0'
  if (type === 'instagram') return '#f50057'
  if (type === 'youtube') return '#FF0000'
  if (type === 'linkedin') return '#0077b5'
  return '#0062E0'
}

export const SocialWrapper = styled.div`
  margin-bottom: 2rem;

  & .subscribebutton {
  }
`
export const SocialLink = styled.a<{ type: string }>`
  display: block;
  color: ${color.grayscale.gray};
  transition: color 0.3s ease;
  margin-bottom: 1rem;
  &:not(:last-of-type) {
    margin-right: ${space.xl};

    @media (min-width: ${breakpoint.lg}) {
      margin-right: ${space.sm};
    }
  }

  &:hover {
    color: ${(p) => getTypeColor(p.type)};
    text-decoration: none;
  }
`
export const NavSocialLink = styled.nav`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 1.5rem;

  @media (min-width: ${breakpoint.lg}) {
    justify-content: flex-start;
  }
`
